<template>
  <v-container fluid class="px-8 py-0">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      <div>
        <v-row>
          <v-switch
            v-model="listQuery.orderby_bill_update"
            label="时间排序"
            style="max-width: 200px;"
            class="mx-3"
            @change="getQuery"
          ></v-switch>
          <v-select
            v-model="listQuery.project_id"
            :items="projectsOptions"
            item-text="name"
            item-value="id"
            menu-props="auto"
            hide-details
            label="项目"
            single-line
            style="max-width: 100px;"
            class="mx-3 mb-3"
            @change="getQuery"
          ></v-select>

          <v-select
            v-model="listQuery.village_id"
            :items="villagesOptions"
            item-text="name"
            item-value="id"
            menu-props="auto"
            hide-details
            label="所在村"
            single-line
            style="max-width: 100px;"
            class="mx-3 mb-3"
            @change="getQuery"
          ></v-select>
          <v-text-field
            v-model="listQuery.customer_name"
            label="姓名"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 65px;"
          />
          <!-- <v-text-field
            v-model="listQuery.sub_name"
            label="受托人"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 80px;"
          /> -->
          <v-text-field
            v-model="listQuery.cardid"
            label="身份证号"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 150px;"
          />
          <v-text-field
            v-model="listQuery.phone"
            label="手机号"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 100px;"
          />
          <v-text-field
            v-model="listQuery.fee"
            label="结算金额"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 100px;"
          />
          <v-select
            v-model="listQuery.garden_name"
            :items="gardenOptions"
            item-text="garden_name"
            item-value="garden_name"
            menu-props="auto"
            hide-details
            label="小区"
            single-line
            style="max-width: 150px;"
            class="mx-3"
            @change="getQuery"
          ></v-select>

          <v-select
            v-model="listQuery.building_name"
            :items="buildingOptions"
            item-text="building_name"
            item-value="building_name"
            menu-props="auto"
            hide-details
            label="幢"
            single-line
            style="max-width: 50px;"
            class="mx-3"
            @change="getQuery"
          ></v-select>

          <v-select
            v-model="listQuery.unit_name"
            :items="unitOptions"
            item-text="unit_name"
            item-value="unit_name"
            menu-props="auto"
            hide-details
            label="单元"
            single-line
            style="max-width: 50px;"
            class="mx-3"
            @change="getQuery"
          ></v-select>

          <v-text-field
            v-model="listQuery.number"
            class="mx-3"
            label="门牌号码"
            hide-details
            single-line
            style="max-width: 80px;"
          />
          <v-menu
            v-model="start_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="listQuery.start_date"
                label="最早更新日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="listQuery.start_date"
              @input="start_menu = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="end_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="listQuery.end_date"
                label="最迟更新日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="listQuery.end_date"
              @input="end_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-row>
      </div>
      <div>
        <v-row class="mt-2">
          <v-btn @click="getQuery" color="primary" class="mx-1">
            查询
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>

          <v-btn @click="resetQuery" color="primary" class="mx-1">
            重置
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>
          <v-btn id="scan" color="primary" class="mx-1">
            扫描
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>
          <export-excel
            v-if="isAdminRole"
            :fields="exportSFields"
            worksheet="户主数据"
            name="魏塘街道公寓房安置户主数据.xls"
            type="xlsx"
            :fetch="getListforExport"
            class="mx-1"
          >
            <v-btn v-if="isAdminRole" color="primary">
              导出
              <v-icon right>mdi-arrow-down-bold-circle-outline</v-icon>
            </v-btn>
          </export-excel>
           <export-excel
            v-if="isAdminRole"
            :fields="exportMFields"
            worksheet="签约数据"
            name="魏塘街道公寓房安置签约数据.xls"
            type="xlsx"
            :fetch="getContractsList"
            class="mx-1"
          >
            <v-btn v-if="isAdminRole" color="primary">
              签约导出
              <v-icon right>mdi-arrow-down-bold-circle-outline</v-icon>
            </v-btn>
          </export-excel>

          <!-- <div v-if="isAdminRole">
            <AddCustomerDialog />
          </div> -->
          <div v-if="isAdminRole">
            <SearchCustomerDialog />
          </div>
          <v-btn @click="readIDCard" color="warning" class="mx-1">
            读取户主身份证
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>
        </v-row>
      </div>
    </v-row>

    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-simple-table fixed-header class="pa-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>姓名</th>
            <th>身份证号</th>
            <th>套数</th>
            <th class="text-right">确认安置面积</th>
            <th class="text-right">标准安置面积</th>
            <th class="text-right">产权置换面积</th>
            <th>电话</th>
            <th>总人数</th>
            <th>农籍人口</th>
            <th>非农人口</th>
            <th>独子农籍</th>
            <th>独子非农</th>
            <th>所在村</th>
            <th>项目名称</th>
            <th class="text-right">结算金额</th>
            <th>结算方案确定时间</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id" :disabled="row.is_freeze==1">
            <td :disabled="row.is_freeze==1">{{ row.id }}</td>
            <td>
              <!-- <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" v-text="icons.lock.icon" /> -->
              <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" >{{ icons.lock.icon }}</v-icon>
              {{ row.name }}
            </td>
            <td>
              {{ row.cardid }}
            </td>
            <td>
              {{ row.contracts.length }}
            </td>
            <td class="text-right">
              {{ row.myarea }}
            </td>
            <td class="text-right">
              {{ row.population_area }}
            </td>
            <td class="text-right">
              {{ row.property_area }}
            </td>
            <td>
              {{ row.phone }}
            </td>
            <td>
              {{ row.population }}
            </td>
            <td>
              {{ row.population_aa }}
            </td>
            <td>
              {{ row.population_na }}
            </td>
            <td>
              {{ row.population_ao }}
            </td>
            <td>
              {{ row.population_no }}
            </td>
            <td>
              {{ row.village }}
            </td>
            <td>
              {{ row.project_real_name }}
            </td>
            <td class="text-right">
              {{ row.total_fee }}
            </td>
            <td>
              <span v-if="row.bill_update">
                {{
                  $moment(row.bill_update)
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss")
                }}
              </span>
            </td>
            <td>
              <v-btn v-if="isAdminRole" color="warning" icon @click="get_customers(row.id)"  :disabled="row.is_freeze==1">
                <!-- <v-icon left v-text="icons.chy.icon" /> -->
                <v-icon left>{{ icons.chy.icon }}</v-icon>
              </v-btn>
              <v-btn v-if="isAdminRole && row.is_freeze==0" :disabled="row.is_freeze==1" color="warning" icon @click="freezeCustomer(row.id)">
                <!-- <v-icon left v-text="icons.unlock.icon" /> -->
                <v-icon left>{{ icons.unlock.icon }}</v-icon>
              </v-btn>
              <v-btn v-if="isAdminRole && row.is_freeze==1" color="warning" icon @click="unfreezeCustomer(row.id)">
                <!-- <v-icon left v-text="icons.lock.icon" /> -->
                <v-icon left>{{ icons.lock.icon }}</v-icon>
              </v-btn>
              <v-btn color="warning" icon @click="get_customer(row.id)" :disabled="row.is_freeze==1">
                <!-- <v-icon left v-text="icons.list.icon" /> -->
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
              <v-btn
              v-if="isAdminRole"
                color="green"
                icon
                :disabled="row.total_fee<=0 || row.is_freeze==1"
                @click="goToBills(row)"
              >
                <!-- <v-icon left v-text="icons.pay.icon" /> -->
                <v-icon left>{{ icons.pay.icon }}</v-icon>
              </v-btn>
              <v-btn
                v-if="isAdminRole"
                icon
                @click="resetBills(row.id)"
                :disabled="row.total_fee<=0 || row.is_freeze==1"
                color="red"
              >
                <v-icon left>mdi-lock-reset</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-pagination
      v-model="listQuery.page"
      :circle="circle"
      :disabled="disabled"
      :length="total_pages"
      :next-icon="nextIcon"
      :prev-icon="prevIcon"
      :total-visible="totalVisible"
      :value="listQuery.page"
      @input="paginationChangeHandler"
      class="my-3"
    ></v-pagination>
     <div style="text-align: right;
    width: 100%;
    margin-bottom: 20px;margin-top: -44px;max-width: 100%;color: gray;">共有{{ total_items }}条记录</div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>

    <v-dialog v-model="dialog" max-width="1200">
      <v-container id="printMe" class="px-3 pt-5 pb-10 dialog-style">
        <v-row class="d-flex justify-space-between mx-1 mb-0">
          <v-card-title class="mx-12 mt-3">
            {{ customer.name }}
          </v-card-title>
          <v-btn v-print="printObj" class="primary no-print">
            <i class="mdi mdi-printer"></i>打印
          </v-btn>
        </v-row>

        <p class="mx-16">{{ customer.village }} {{ customer.address }} {{ customer.cardid }}</p>
        <v-simple-table dense class="mx-15 mt-6 dialog-style" v-if="customer">
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  序号
                </th>
                <th>
                  总额(元)
                </th>
                <th class="text-right">
                  交房结算方案明细
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- v-if="customer.bill_seq==(i+1)" -->
              <template v-for="(row, i) in customer.tempbills">
              <tr :key="row.id" :style="{backgroundColor: customer.bill_seq==(i+1) ? 'rgba(255,255,255,.5)' : 'none'}">
                <td>{{ i + 1 }}</td>
                <td>{{ row.total_fee }}</td>
                <td
                  v-for="(item, i) in row.tempdetails"
                  :key="i"
                  class="text-right"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div icon v-bind="attrs" v-on="on">
                        {{ item.area }}㎡
                        <span :class="`bill_background-${item.seq}`">{{
                          item.total_fee
                        }}</span>
                      </div>
                    </template>
                    <span>
                      <v-chip color="orange" text-color="white">
                        <span class="tooltip">
                          {{ item.garden }}{{ item.building }}幢{{
                            item.unit
                          }}单元{{ item.number }}室，{{ item.area }}㎡
                        </span></v-chip
                      >
                    </span>
                  </v-tooltip>
                  <span class="only-print">
                    {{ item.garden }}{{ item.building }}幢{{ item.unit }}单元{{
                      item.number
                    }}室
                  </span>
                </td>
                <v-btn
                  v-if="customer.total_fee<=0 && isAdminRole"
                  icon
                  color="primary"
                  class="mx-6 no-print"
                  @click="generateContracts(row.id,i+1)"
                >
                  <!-- <v-icon left v-text="icons.checkin.icon" /> -->
                  <v-icon left>{{ icons.checkin.icon }}</v-icon>
                </v-btn>
              </tr>
            </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-dialog>
    <v-dialog v-model="Interest" max-width="1200">
      <v-container id="printMe" class="px-3 pt-5 pb-10 dialog-style">
        <v-row class="d-flex justify-space-between mx-1 mb-0">
          <v-card-title class="mx-12 mt-3">
            {{ customer.name }}
          </v-card-title>
        </v-row>

        <p class="mx-16">{{ customer.village }} {{ customer.cardid }}</p>
        <v-simple-table dense class="mx-15 mt-6 dialog-style" v-if="customer">
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  序号
                </th>
                <th>
                  预缴房款(元)
                </th>
                <th>
                  暂缓领款(元)
                </th>
                <th>
                  补偿总金额(元)
                </th>
                <th>
                  起始时间
                </th>
                <th>
                  结束时间
                </th>
                <th>
                  贴息金额(元)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in customer.interest" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ row.prepay_fee }}</td>
                <td>{{ row.defer_fee }}</td>
                <td>{{ row.total_fee }}</td>
                <td>{{
                  $moment(row.start_date)
                    .utc()
                    .format("YYYY-MM-DD")
                }}</td>
                <td>{{
                  $moment(row.end_date)
                    .utc()
                    .format("YYYY-MM-DD")
                }}</td>
                <td>{{ Math.round(row.interest_fee) }}</td>
                <v-btn
                  v-if="isAdminRole"
                  icon
                  color="primary"
                  class="mx-6 no-print"
                  @click="goToInterest(row.id)"
                >
                  <!-- <v-icon left v-text="icons.single.icon" /> -->
                  <v-icon left>{{ icons.single.icon }}</v-icon>
                </v-btn>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  fetchCustomer,
  fetchCustomers,
  updateCustomer,
  deleteCustomer,
  updateCustomerById,
  fetchGarden,
  fetchBuilding,
  fetchUnit
} from "@/api/customers";

import { fetchProjectsList } from "@/api/projects";
import { fetchVillagesList } from "@/api/villages";
import { updateContractByTempbill,fetchContracts } from "@/api/contracts";
import { getReaderInfo,readIDCard } from "@/api/idcard";

const checkFlagOptions = [
  { key: 0, display_name: "✘" },
  { key: 1, display_name: "✔" }
];

const batchCodeOptions = [
  { key: "01", display_name: "01" },
  { key: "02", display_name: "02" },
  { key: "03", display_name: "03" }
];

const orderByOptions = [
  { key: "1", display_name: "入场号↑" },
  { key: "2", display_name: "抽签号↑" }
];

export default {
  name: "Customers",
  components: {
    // AddCustomerDialog: () => import("./addCustomerDialog"),
    SearchCustomerDialog: () => import("./searchCustomerDialog")
  },
  data: () => ({
    printObj: {
      id: "printMe",
      popTitle: "good print",
      extraCss: "https://www.baidu.com",
      extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
    },
    dialog: false,
    Interest:false,
    snackbar: false,
    text: "",
    timeout: 3000,
    icons: {
      single: {
        color: "blue",
        icon: "mdi-printer"
      },
      batch: {
        color: "secondary",
        icon: "mdi-printer"
      },
      pay: {
        color: "green",
        icon: "mdi-cash-100"
      },
      list: {
        color: "",
        icon: "mdi-format-list-bulleted"
      },
      delete: {
        color: "green",
        icon: "mdi-delete"
      },
      heart: {
        color: "green",
        icon: "mdi-heart-box"
      },
      action: {
        color: "info",
        icon: "mdi-account-details"
      },
      checkin: {
        color: "info",
        icon: "mdi-checkbox-marked-circle"
      },
      chy:{
        color:"info",
        icon:"mdi-currency-jpy"
      },
      print:{
        color:"info",
        icon:"mdi-printer"
      },
      lock:{
        color:"info",
        icon:"mdi-lock"
      },
      unlock:{
        color:"info",
        icon:"mdi-lock-open"
      }
    },
    start_menu: "",
    end_menu: "",

    alert: false,
    alert_text: "",

    temp: {
      admission_sequence: undefined,
      lottery_sequence: undefined,
      population: undefined,
      phone: undefined
    },
    villagesOptions: [],
    projectsOptions: [],
    gardenOptions: [],
    buildingOptions: [],
    unitOptions: [],
    checkFlagOptions,
    batchCodeOptions,
    orderByOptions,
    items: [],
    customer: {},
    listQuery: {
      page: 1,
      limit: 12,
      customer_code: undefined,
      customer_name: undefined,
      status: undefined,
      remain_area_greater_twenty: undefined,
      sort: "+id",
      orderby: undefined,
      paged: 1,
      check_flag: undefined,
      village_id: undefined,
      start_date: undefined,
      end_date: undefined,
      orderby_bill_update: undefined,
    },
    villages: "",
    search: "",
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    total_items:0,
    greenColor: "rgb(81, 185, 116)",
    greyColor: "rgb(160, 160, 160)",
    redColor: "rgb(231, 111, 111)",
    orangeColor: "rgb(247, 172, 11)",
    exportFields: {
      id: "id",
      实际项目名称: "project_real_name",
      户主编号: "customer_code",
      入场号: "admission_sequence",
      顺序号: "lottery_sequence",
      户主名称: "name",
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      套数: "contracts.length",
      电话: "phone",
      总人数: "population",
      农籍人口: "population_aa",
      非农人口: "population_na",
      独子农籍: "population_ao",
      独子非农: "population_no",
      核定占地面积: "zhandi_area",
      核定建筑面积: "jianzhu_area",
      标准安置面积: "population_area",
      产权置换面积: "property_area",
      确认安置面积: "myarea",
      确认安置面积2: "population_area_remain",
      确认安置面积3: "property_area_remain",
      所在村: "village",
      具体地址: "address",
      项目名称: "project",
      场次:"batch_code",
      备注:"note",
      结算金额: "total_fee",
      结算方案确定时间: "bill_update",
      导入时间: "create_at_export",
    },
    exportMBFields: {
      id: "id",
      户主名称: "name",
      项目名称: "project",
      实际项目名称: "project_real_name",
      顺序号: "lottery_sequence",
      状态:"contracts.length",
      所在村: "village",
      具体地址: "address",
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      电话: "phone",
      // 腾空时间:"empty_time",
      总人数: "population",
      农籍人口: "population_aa",
      非农人口: "population_na",
      独子农籍: "population_ao",
      独子非农: "population_no",
      核定占地面积: "zhandi_area",
      核定建筑面积: "jianzhu_area",
      标准安置面积: "population_area",
      产权置换面积: "property_area",
      确认安置面积: "myarea",
      备注:"note",
      套数: "contracts.length",
      结算金额: "total_fee",
      结算方案确定时间: "bill_update"
    },
    exportHFields: {
      id: "id",
      户主名称: "name",
      性别: {
        field: "cardid",
        callback: value => {
          return '';
        }
      },
      所在村: "village",
      证件类型:{
        field: "cardid",
        callback: value => {
          return '身份证';
        }
      },
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      关系: {
        field: "cardid",
        callback: value => {
          return '户主';
        }
      },
      腾空时间:"empty_time",
      确认安置面积: "myarea",
    },
    exportSFields: {
      序号: "id",
      入场号: "admission_sequence",
      顺序号: "lottery_sequence",
      项目名称: "project",
      实际项目名称: "project_real_name",
      户主名称: "name",
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      电话: "phone",
      选房数量:"contracts.length",
      交房数量:"deliver_count",
      腾空时间: "empty_time",
      腾空时间后30个月: "empty_time2",
      腾空时间后66个月: "empty_time3",
      交房时间段: "admission_sequence",
      行政村: "village",
      具体地址: "address",
      总人数: "population",
      农籍人口: "population_aa",
      非农人口: "population_na",
      独子农籍: "population_ao",
      独子非农: "population_no",
      确认安置面积: "myarea",
      过渡费1: "transition_fee_before",
      过渡费2: "transition_fee_after",
      过渡费3: {
        field: "transition_fee_after",
        callback: value => {
          return value*2
          
        }
      },
      // 过渡费单价: "transition_unit_fee",
      已发放过渡费: "transition.transition_issued",
      总过渡费: "transition.transition_total",
      过渡费差价: "transition.transition_diff",
      是否拆迁公司计算: "transition_is_company",
      所属拆迁公司: "company_name",
      方案: "bill_seq",
      结算金额: "total_fee",
      选房结果1: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积1: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间1: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果1过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      每月1过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.meiyue;
            }
          }
          
        }
      },
      选房结果1拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      选房结果1标准面积: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.population_area;
            }
          }
          
        }
      },
      选房结果1产权置换面积: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.property_area;
            }
          }
          
        }
      },
      选房结果1特殊价格面积: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.special_area;
            }
          }
          
        }
      },
      选房结果1不可分割面积: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.extend_area;
            }
          }
          
        }
      },
      // 交房时间1: "admission_sequence",
      // 选房结果1过渡费: "admission_sequence",
      选房结果2: {
        field: "contracts",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const contract = value[1];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积2: {
        field: "contracts",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const contract = value[1];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间2: {
        field: "contracts",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const contract = value[1];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果2过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const contract = value[1];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      每月2过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.meiyue;
            }
          }
          
        }
      },
      选房结果2拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const contract = value[1];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      // 交房时间2: "admission_sequence",
      // 选房结果2过渡费: "admission_sequence",
      选房结果3: {
        field: "contracts",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const contract = value[2];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积3: {
        field: "contracts",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const contract = value[2];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间3: {
        field: "contracts",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const contract = value[2];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果3过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const contract = value[2];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      每月3过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.meiyue;
            }
          }
          
        }
      },
      选房结果3拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const contract = value[2];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      // 交房时间3: "admission_sequence",
      // 选房结果3过渡费: "admission_sequence",
      选房结果4: {
        field: "contracts",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const contract = value[3];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积4: {
        field: "contracts",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const contract = value[3];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间4: {
        field: "contracts",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const contract = value[3];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果4过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const contract = value[3];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      每月4过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.meiyue;
            }
          }
          
        }
      },
      选房结果4拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const contract = value[3];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      // 交房时间4: "admission_sequence",
      // 选房结果4过渡费: "admission_sequence",
      选房结果5: {
        field: "contracts",
        callback: value => {
          if (typeof(value[4]) != "undefined"){
            const contract = value[4];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积5: {
        field: "contracts",
        callback: value => {
          if (typeof(value[4]) != "undefined"){
            const contract = value[4];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间5: {
        field: "contracts",
        callback: value => {
          if (typeof(value[4]) != "undefined"){
            const contract = value[4];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果5过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[4]) != "undefined"){
            const contract = value[4];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      每月5过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const contract = value[0];
            if (contract) {
              return contract.meiyue;
            }
          }
          
        }
      },
      选房结果5拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[4]) != "undefined"){
            const contract = value[4];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      选房结果6: {
        field: "contracts",
        callback: value => {
          if (typeof(value[5]) != "undefined"){
            const contract = value[5];
            if (contract) {
              return contract.garden_name+contract.building_name+"幢"+contract.unit_name+"单元"+contract.house_number+"室";
            }
          }
          
        }
      },
      选房面积6: {
        field: "contracts",
        callback: value => {
          if (typeof(value[5]) != "undefined"){
            const contract = value[5];
            if (contract) {
              return contract.area+"㎡";
            }
          }
          
        }
      },
      交房时间6: {
        field: "contracts",
        callback: value => {
          if (typeof(value[5]) != "undefined"){
            const contract = value[5];
            if (contract) {
              return contract.delivery_time_export;
            }
          }
          
        }
      },
      选房结果6过渡费: {
        field: "contracts",
        callback: value => {
          if (typeof(value[5]) != "undefined"){
            const contract = value[5];
            if (contract) {
              return contract.transitionTotal;
            }
          }
          
        }
      },
      选房结果6拆迁公司: {
        field: "contracts",
        callback: value => {
          if (typeof(value[5]) != "undefined"){
            const contract = value[5];
            if (contract) {
              return contract.conmpany_name;
            }
          }
          
        }
      },
      // 交房时间5: "admission_sequence",
      // 选房结果5过渡费: "admission_sequence",
      备注: "admission_sequence",
      
    },
    exportMFields: {
      序号: "id",
      项目名称: "project_name",
      实际项目名称: "project_real_name",
      顺序号: "customer_lottery_sequence",
      户主名称: "customer",
      户主编号: {
        field: "code",
        callback: value => {
          return `'${value}`;
        }
      },
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      手机号码: "phone",
      行政村: "village",
      具体地址: "address",
      腾空时间:"empty_time",
      小区: "garden_name",
      楼幢: {
        field: "building_name",
        callback: value => {
          return `'${value}`;
        }
      },
      单元: "unit_name",
      房号: "house_number",
      面积: "area",
      楼层: "floor",
      楼高: "floors",
      层级差: "feefloat",
      标准价:"population_price_discount",
      标准面积:"population_area",
      标准金额:"population_fee",
      产权置换价:"property_price_discount",
      产权置换面积:"property_area",
      产权置换金额:"property_fee",
      特殊价格:"special_price_discount",
      特殊面积:"special_area",
      特殊金额:"special_fee",
      不可分割价:"extend_price_discount",
      不可分割面积:"extend_area",
      不可分割金额:"extend_fee",
      市场优惠价:"market_discount_price_discount",
      市场优惠面积:"market_discount_area",
      市场优惠金额:"market_discount_fee",
      车库编号: "sub_name",
      车库面积: "sub_area",
      车库金额: "sub_fee",
      房款金额: "house_fee",
      房款车库金额: "total_house_fee",
      物业专项维修基金: "repair_special_fee",
      车库维修基金: "sub_repair_fee",
      代收费: "proxy_fees",
      总金额: "total_fee",
      产权人: {
        field: "agreement",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const agreement = value[0];
            if (agreement) {
              return agreement.customer;
            }
          }
          
        }
      },
      交房时间: {
        field: "delivery_time_export",
        callback: value => {
          return `'${value}`;
        }
      },
      是否交款: {
        field: "is_pay",
        callback: value => {
          if (value==1){
            return '已交款'
          }else{
            return '未交款'
          }
        }
      },
      完成时间: "success_time_export",
      导入时间: "create_at_export",
    },
    exportHTFields: {
      序号: "id",
      项目名称: "project_name",
      实际项目名称: "project_real_name",
      小区: "garden_name",
      楼幢: {
        field: "building_name",
        callback: value => {
          return `'${value}`;
        }
      },
      单元: "unit_name",
      房号: "house_number",
      购房人: {
        field: "agreement",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const agreement = value[0];
            if (agreement) {
              return agreement.customer;
            }
          }
          
        }
      },
       面积: "area",
      
      合同金额: "total_fee",
      合同时间: "delivery_time_export",
    },
    exportDJFields: {
      所属项目: "project_real_name",
      小区: "garden_name",
      楼幢: {
        field: "building_name",
        callback: value => {
          return `'${value}`;
        }
      },
      单元: "unit_name",
      房号: "house_number",
      面积: "area",
      户型:"1",
      户型图:"1",
      户主:"customer",
      产权人: {
        field: "agreement",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const agreement = value[0];
            if (agreement) {
              return agreement.customer;
            }
          }
          
        }
      },
      行政村: "village",
      具体地址: "address",
      状态:"已选",
      交房时间: {
        field: "delivery_time_export",
        callback: value => {
          return `'${value}`;
        }
      },
      备注:"note"
    },
    exportJFields: {
      序号: "id",
      项目名称: "project",
      实际项目名称: "project_real_name",
      行政村: "village",
      具体地址: "address",
      户主名称: "name",
      确认安置面积: "myarea",
      已选数量:"has_contracts",
      已交数量:"deliver_contracts",
      预交房款: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.prepay_fee;
            }
          }
          
        }
      },
      暂缓领款: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.defer_fee;
            }
          }
          
        }
      },
      补偿总金额: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.total_fee;
            }
          }
          
        }
      },
      起始时间: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.start_date;
            }
          }
          
        }
      },
      结束时间: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.end_date;
            }
          }
          
        }
      },
      贴息奖励: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return Math.round(interest.interest_fee);
            }
          }
          
        }
      },
      备注: {
        field: "interest",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const interest = value[0];
            if (interest) {
              return interest.note;
            }
          }
          
        }
      },
      预交房款1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.prepay_fee;
            }
          }
          
        }
      },
      暂缓领款1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.defer_fee;
            }
          }
          
        }
      },
      补偿总金额1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.total_fee;
            }
          }
          
        }
      },
      起始时间1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.start_date;
            }
          }
          
        }
      },
      结束时间1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.end_date;
            }
          }
          
        }
      },
      贴息奖励1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return Math.round(interest.interest_fee);
            }
          }
          
        }
      },
      备注1: {
        field: "interest",
        callback: value => {
          if (typeof(value[1]) != "undefined"){
            const interest = value[1];
            if (interest) {
              return interest.note;
            }
          }
          
        }
      },
      预交房款2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.prepay_fee;
            }
          }
          
        }
      },
      暂缓领款2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.defer_fee;
            }
          }
          
        }
      },
      补偿总金额2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.total_fee;
            }
          }
          
        }
      },
      起始时间2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.start_date;
            }
          }
          
        }
      },
      结束时间2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.end_date;
            }
          }
          
        }
      },
      贴息奖励2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return Math.round(interest.interest_fee);
            }
          }
          
        }
      },
      备注2: {
        field: "interest",
        callback: value => {
          if (typeof(value[2]) != "undefined"){
            const interest = value[2];
            if (interest) {
              return interest.note;
            }
          }
          
        }
      },
      预交房款3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.prepay_fee;
            }
          }
          
        }
      },
      暂缓领款3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.defer_fee;
            }
          }
          
        }
      },
      补偿总金额3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.total_fee;
            }
          }
          
        }
      },
      起始时间3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.start_date;
            }
          }
          
        }
      },
      结束时间3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.end_date;
            }
          }
          
        }
      },
      贴息奖励3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return Math.round(interest.interest_fee);
            }
          }
          
        }
      },
      备注3: {
        field: "interest",
        callback: value => {
          if (typeof(value[3]) != "undefined"){
            const interest = value[3];
            if (interest) {
              return interest.note;
            }
          }
          
        }
      },
    }
  }),

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
    this.getVillagesList();
    this.getProjectsList();
    this.getGardens();
    this.getBuildings();
    this.getUnits();
  },
  // watch: {
  //     search: function (val) {
  //       if (!this.awaitingSearch) {
  //         setTimeout(() => {
  //           this.getList()
  //           this.awaitingSearch = false
  //         }, 1500); // 1 sec delay
  //       }
  //       this.awaitingSearch = true
  //     },
  //   },
  mounted: {
   
  },
  methods: {
    // rules_start_date() {
    //   if (this.start_date > this.end_date) {
    //     this.start_date = this.end_date;
    //   }
    // },

    // rules_end_date() {
    //   if (this.end_date < this.start_date) {
    //     this.end_date = this.start_date;
    //   }
    // },
    scan(){

    },
    getQuery() {
      this.listQuery.page = 1;
      if (this.listQuery.start_date || this.listQuery.end_date) {
        this.listQuery.orderby_bill_update = true;
      }
      this.getList();
      // this.getVillagesList();
    },
    changed() {},
    getList() {
      this.listLoading = true;
      this.listQuery.limit = 12;
      console.log(this.listQuery);
      fetchCustomers(this.listQuery).then(response => {
        this.items = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        this.total_items = response.data._meta.total_items;
        console.log(this.items);

        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    getProjectsList() {
      this.listLoading = true;
      console.log("getProjectsList");
      fetchProjectsList().then(response => {
        this.projectsOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },

    getVillagesList() {
      this.listLoading = true;
      console.log("getVillagesList");
      fetchVillagesList().then(response => {
        this.villagesOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },

    getListforExport() {
      this.listLoading = true;
      this.listQuery.page = 1;
      this.listQuery.limit = 450;
      fetchCustomers(this.listQuery).then(response => {
        this.exportItems = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      return this.exportItems;
    },
    getContractsList() {
      console.log("xxxx");
      this.listLoading = true;
      // this.listQuery.page = 1;
      this.listQuery.limit = 4000;
      this.listQuery.orderby_id_desc = true;
      fetchContracts(this.listQuery).then(response => {
        this.exportMItems = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      return this.exportMItems;
    },

    get_customer(customer_id) {
      this.dialog = true;
      fetchCustomer(customer_id).then(response => {
        this.customer = response.data;
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    cancelDialog() {
      this.dialog = false;
    },
    get_customers(customer_id) {
      this.Interest = true;
      fetchCustomer(customer_id).then(response => {
        this.customer = response.data;
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    cancelInterest() {
      this.interest = false;
    },

    goToBills(row) {
      // console.log(row.id)
      this.$router.push({
        name: "结算管理",
        params: { id: row.id }
      });
    },

    goToInterest(id) {
      // console.log(row.id)
      this.$router.push({
        name: "打印贴息单",
        params: { id: id }
      });
    },

    freezeCustomer(id) {
      console.log("freezeCustomer");
      this.$confirm("确定要冻结当前户主吗?").then(res => {
        const data = { is_freeze: 1 };
        if (res) {
          updateCustomerById(id,data).then(response => {
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前用户已冻结！";
              this.snackbar = true;
            }
          });
          this.dialog = false;
        }
      });
    },
    unfreezeCustomer(id) {
      console.log("checkinCustomer");
      this.$confirm("确定要解冻当前户主吗?").then(res => {
        const data = { is_freeze: 2 };
        if (res) {
          updateCustomerById(id,data).then(response => {
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前用户已解冻！";
              this.snackbar = true;
            }
          });
          this.dialog = false;
        }
      });
    },
    generateContracts(tempbill_id,seq) {
      this.$confirm("现在生成交房结算数据?").then(res => {
        const data = { tempbill_id: tempbill_id,seq:seq };
        if (res) {
          updateContractByTempbill(data).then(response => {
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "交房结算数据已经生成！";
              this.snackbar = true;
            }
          });
          this.dialog = false;
        }
      });
    },

    resetQuery() {
      this.listQuery.orderby = undefined;
      this.listQuery.id = undefined;
      this.listQuery.cardid = undefined;
      this.listQuery.customer_name = undefined;
      this.listQuery.status = undefined;
      this.listQuery.check_flag = undefined;
      this.listQuery.project_id = undefined;
      this.listQuery.village_id = undefined;
      this.listQuery.garden_name = undefined;
      this.listQuery.building_name = undefined;
      this.listQuery.unit_name = undefined;
      this.listQuery.house_number = undefined;
      this.listQuery.remain_area_greater_twenty = undefined;
      this.listQuery.start_date = undefined;
      this.listQuery.end_date = undefined;
      this.listQuery.phone = undefined;
      this.listQuery.orderby_bill_update = undefined;
      this.listQuery.fee = undefined;
      this.getList();
      console.log("resetQuery");
    },
    getGardens() {
      fetchGarden().then(response => {
        this.gardenOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("gardenOptions:", this.gardenOptions);
    },
    getBuildings() {
      fetchBuilding().then(response => {
        this.buildingOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("buildingOptions:", this.buildingOptions);
    }, 
    getUnits() {
      fetchUnit().then(response => {
        this.unitOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("unitOptions:", this.unitOptions);
    },   
    resetBills(customer_id) {
      this.listLoading = true;
      this.$confirm("确定需要删除结算数据?").then(res => {
        if (res) {
          var data = {
            reset_bill: 1
          };
          updateCustomer(customer_id, data).then(response => {
            this.getList();
            setTimeout(() => {
              this.listLoading = false;
            }, 5 * 1000);
          });
        }
      });
    },

    addChoice(row) {
      // console.log(row.id)
      this.$router.push({
        name: "预选方案",
        params: { id: row.id }
      });
    },

    removeCustomer(row) {
      this.$confirm("确认删除户主资料?").then(res => {
        if (res) {
          deleteCustomer(row.id).then(response => {
            // console.log('response: ', response)
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "户主资料删除成功！";
              this.snackbar = true;
            }
          });
        }
      });
    },

    paginationChangeHandler(pageNumber) {
      console.log("paginationChangeHandler, pageNumber: ", pageNumber);
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },

    getNamefromOptions(options, key) {
      // return options[key]
      let showname = "";
      options.forEach(item => {
        if (item.key === key) {
          // console.log(key, item.key, item.display_name)
          showname = item.display_name;
        }
      });
      return showname;
    },

    save(row) {
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (
        (this.temp.admission_sequence &&
          !numRe.test(this.temp.admission_sequence)) ||
        (this.temp.lottery_sequence &&
          !numRe.test(this.temp.lottery_sequence)) ||
        (this.temp.population && !numRe.test(this.temp.population)) ||
        (this.temp.phone && !numRe.test(this.temp.phone))
      ) {
        this.alert_text =
          "数据输入有误, " +
          "当前输入值为 " +
          this.temp.lottery_sequence +
          ";" +
          this.temp.population;
        ("，请输入有效数字！");
        this.alert = true;
      } else {
        this.alert = false;
        // var data = { lottery_sequence: this.lottery_sequence };
        updateCustomer(row.id, this.temp).then(response => {
          console.log(response.data);
          if (response.data.error) {
            this.alert_text = response.data.error;
            this.alert = true;
          } else {
            this.getList();
            // Just to simulate the time of the request
            this.text = row.name + " 数据更新完成!";
            this.snackbar = true;
          }
        });
        this.temp = {
          lottery_sequence: undefined,
          population: undefined,
          phone: undefined
        };
      }
    },
    readerInit(wzxx) {
		
      if( this.websocket_supported == false || this.socket.readyState == 2 || this.socket.readyState == 3) {
        this.websocket_supported = this.wsOpen();
      }

      if( ! this.jsonp_supported) {
        getReaderInfo().then(response => {
          console.log(response);
          if(response.status == 200){
            this.jsonp_supported = true;
          }else{
            this.jsonp_supported = false;
          }
          
        });
      }
    },
    parseCardInfo(text) {
      var result = {};
      result['name'] = text.substr(0, 15).trim();
      result['gender'] = text.substr(15, 1).trim();
      result['race_id'] = text.substr(16, 2).trim();
      result['birthday'] = text.substr(18, 8).trim();
      result['address'] = text.substr(26, 35).trim();
      result['IDNumber'] = text.substr(61, 18).trim();
      result['issuer'] = text.substr(79, 15).trim();
      result['valied'] = text.substr(94, 8).trim();
      result['expire'] = text.substr(102, 8).trim();
      result['type'] = text.substr(124, 1).trim();

      if (result['type'] == 'J'){
        result['PassNumber'] = text.substr(110, 9);
        result['issueCount'] = text.substr(119, 2);
      }
      else if (result['type'] == 'I'){
        return false;
      }
      return result;
    },

    onWsOpen(evt) { 
    },
  
    onWsClose(evt) { 
    },

    onWsMessage(evt){ 
      var jsondata = JSON.parse(evt.data);
      
      // this.writeToScreen(evt.data); 

      if(jsondata.module == "idcard" && jsondata.function == "readcard" ) {
        
        if(jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return ;
        }
        var	result = this.parseCardInfo(jsondata.data.text);
        console.log("获取身份证数据");
        this.listQuery.cardid = result.IDNumber
        this.getList();
      }
      else if(jsondata.module == "idcard" && jsondata.function == "getsam" ) {
        if(jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return ;
        }
      }
      else if(jsondata.module == "iccard" && jsondata.function == "getidsnr" ) {
        if(jsondata.ret != 0) {
          return ;
        }
      }
      else {
        return false
      }
    },
 
    onWsError(evt) { 
    },
  
    doSend(message) {
      this.socket.send(message); 
    }, 
    wsOpen()
    {
      if(typeof(WebSocket) == "undefined"){
        return false;
      }

      let that = this
      this.socket = new WebSocket(this.wsUri); 
      this.socket.onopen = function(evt) { 
        that.onWsOpen(evt) 
      }; 
      this.socket.onclose = function(evt) { 
        that.onWsClose(evt) 
      }; 
      this.socket.onmessage = function(evt) { 
        that.onWsMessage(evt) 
      }; 
      this.socket.onerror = function(evt) { 
        that.onWsError(evt) 
      }; 

      return true;
    },
    
    wsClose()
    {
      this.socket.close(); 
    },

    onJsopReadCard(resultInfo, status) {
      console.info("readIDCard ", resultInfo, status);
      // $("#output").text(JSON.stringify(resultInfo));
      if( resultInfo.result === 0 ){

        var	result = this.parseCardInfo(resultInfo.wzInfo);
        
      }
      else {
        //alert(resultInfo.errorMsg);
      }

    },

    getInfo()
    {
      this.msgid = this.msgid+1;
      this.doSend("{\"module\":\"common\",\"msgid\":\"" + this.msgid+  "\",\"function\":\"info\"}"); 
    },
    readIdCard()
    {
      this.is_entrust = false;
        // console.log("点击买受人数据");
        // console.log(this.is_entrust);
      this.msgid = this.msgid+1;
      if(this.websocket_supported && this.socket.readyState == 1) {
        this.doSend("{\"module\":\"idcard\",\"msgid\":\"" + this.msgid+  "\",\"function\":\"readcard\"}"); 
      }
      else if(this.jsonp_supported) {
        
        readIDCard().then(response => {
          this.onJsopReadCard()
        });
      }
      else {
        console.log("未检测到阅读器插件!");
      }
    
	},

    cancel() {},
    open() {},
    close() {}
  }
};
</script>

<style lang="scss" scoped>
$colors: (
  0 #03444d,
  1 #80594a,
  2 #4e3152,
  3 #856936,
  4 #255834,
  5 #2e3761,
  6 #6d2b36,
  7 #2b6d6a,
  8 #413370,
  9 #754719
);

$color: nth($colors, random(length($colors)));

@each $i in $colors {
  .bill_background-#{nth($i,1)} {
    background-color: nth($i, 2) !important;
    color: rgb(241, 233, 233) !important;
    font-weight: 500 !important;
    border-radius: 1px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    width: 92px;
  }
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table,
thead,
tr {
  // color: rgb(160, 160, 160);
  font-weight: 400;
}
th,
td {
  text-align: center !important;
  vertical-align: middle;
  padding: 0 2px 0 2px !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}

.tooltip {
  font-size: 16px;
}

.only-print {
  display: none;
}

@page {
  /* size: A4; */
  size: landscape;
  margin: 1px 1px;
}

@media print {
  .A4 {
    background: white;
    /* width: 21cm;
  height: 29.7cm; */
    width: 1122px;
    height: 794px;
    display: block;
    margin: auto;
    padding: auto;
    margin-bottom: 0cm;
    box-shadow: 0 0 0.5cm 0.5cm rgba(90, 88, 88, 0.1);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .dialog-style {
    background-color: rgb(255, 254, 254) !important;
  }

  .no-print {
    display: none;
  }

  .only-print {
    display: block;
    font-weight: 400;
    font-size: 12px !important;
  }

  table,
  th,
  td {
    color: black !important;
    font-weight: 800;
    border: 1px solid !important;
    border-collapse: separate !important;
    // border-spacing: 5 !important;
  }
}
</style>
